import {
    IArtistsListParams, IArtistsListSorting,
} from '@tacans/shared-marketplace-layer';
import { EArtistSortBy, IFetchArtistParams } from 'src/features/common/artist/artist.types';


export const mapSorting = (sort?: EArtistSortBy): IArtistsListSorting => {
    switch(sort) {
        case EArtistSortBy.LATEST:
            return {
                sortBy: 'Date',
                ascending: false
            };
        case EArtistSortBy.OLDEST:
            return {
                sortBy: 'Date',
                ascending: true
            };
        case EArtistSortBy.NAME_ASC:
            return {
                sortBy: 'Name',
                ascending: true
            };
        case EArtistSortBy.NAME_DESC:
            return {
                sortBy: 'Name',
                ascending: false
            };
        default:
            return {
                sortBy: 'Date',
                ascending: false
            };
    }
};

export const createArtistFetchFilterPayload = ({ sort, filter, pager }: IFetchArtistParams): IArtistsListParams => ({
    sorting: mapSorting(sort),
    filter,
    pager: {
        page: pager?.page ?? 0,
        limit: pager?.limit ?? 20,
    },
});